import { render, staticRenderFns } from "./list-bottom.vue?vue&type=template&id=926e5b1c"
import script from "./list-bottom.vue?vue&type=script&lang=js"
export * from "./list-bottom.vue?vue&type=script&lang=js"
import style0 from "./list-bottom.vue?vue&type=style&index=0&id=926e5b1c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports